var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getCars)?_c('div',{staticClass:"content-area",domProps:{"innerHTML":_vm._s(_vm.getCars)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }